import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.31254 5.00002L13.3334 10.0209L8.31254 15.0417L7.41671 14.1459L11.5417 10.0209L7.41671 5.89585L8.31254 5.00002Z",
		fill: "#D0DFE4"
	})
});
export default SvgArrowRight;
